import axios from 'axios';
import { getAuthToken } from '../utils/sessionAuth.js';

const API_URL = `${process.env.REACT_APP_BACKEND_SERVER}/api/vpp`;

const authHeaders = () => {
  const token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const jsonHeaders = () => ({ ...authHeaders(), 'Content-Type': 'application/json' });

const getAppIcons = async (bundleIds, { refresh = false } = {}) => {
  const ids = [...new Set((bundleIds || []).map(String).filter(Boolean))];
  if (!ids.length) return { icons: {}, cacheTtlDays: 7 };
  const response = await axios.get(`${API_URL}/app-icons`, {
    headers: authHeaders(),
    params: {
      bundleIds: ids.join(','),
      ...(refresh ? { refresh: '1' } : {}),
    },
    timeout: 60000,
  });
  return response.data;
};

const getAssets = async ({ q, productType, refresh } = {}) => {
  const params = {};
  if (q) params.q = q;
  if (productType) params.productType = productType;
  if (refresh) params.refresh = '1';
  const response = await axios.get(`${API_URL}/assets`, {
    headers: authHeaders(),
    params,
    timeout: 120000,
  });
  return response.data;
};

const getAsset = async (adamId) => {
  const response = await axios.get(`${API_URL}/assets/${encodeURIComponent(adamId)}`, {
    headers: authHeaders(),
    timeout: 120000,
  });
  return response.data;
};

const getAppLicenses = async (adamId) => {
  const response = await axios.get(`${API_URL}/apps/${encodeURIComponent(adamId)}/licenses`, {
    headers: authHeaders(),
    timeout: 120000,
  });
  return response.data;
};

const disassociateLicenses = async (adamId, payload) => {
  const response = await axios.post(
    `${API_URL}/apps/${encodeURIComponent(adamId)}/licenses/disassociate`,
    payload,
    { headers: jsonHeaders(), timeout: 120000 }
  );
  return response.data;
};

const getAppConfigs = async (adamId) => {
  const params = adamId ? { adamId } : {};
  const response = await axios.get(`${API_URL}/app-configs`, { headers: authHeaders(), params });
  return response.data;
};

const createAppConfig = async (payload) => {
  const response = await axios.post(`${API_URL}/app-configs`, payload, { headers: jsonHeaders() });
  return response.data;
};

const updateAppConfig = async (id, payload) => {
  const response = await axios.put(`${API_URL}/app-configs/${id}`, payload, { headers: jsonHeaders() });
  return response.data;
};

const deleteAppConfig = async (id) => {
  const response = await axios.delete(`${API_URL}/app-configs/${id}`, { headers: authHeaders() });
  return response.data;
};

const putAppAssignments = async (adamId, { groups, catalogApp }) => {
  const response = await axios.put(
    `${API_URL}/apps/${encodeURIComponent(adamId)}/assignments`,
    { groups, catalogApp },
    { headers: jsonHeaders() }
  );
  return response.data;
};

const getDeviceApps = async (udid) => {
  const response = await axios.get(`${API_URL}/devices/${encodeURIComponent(udid)}/apps`, {
    headers: authHeaders(),
  });
  return response.data;
};

const reinstallDeviceApp = async (udid, adamId) => {
  const response = await axios.post(
    `${API_URL}/devices/${encodeURIComponent(udid)}/apps/${encodeURIComponent(adamId)}/reinstall`,
    {},
    { headers: jsonHeaders() }
  );
  return response.data;
};

const removeDeviceApp = async (udid, adamId, { disable = false, force = false, bundleId } = {}) => {
  const response = await axios.post(
    `${API_URL}/devices/${encodeURIComponent(udid)}/apps/${encodeURIComponent(adamId)}/remove`,
    { disable, force, bundleId },
    { headers: jsonHeaders() }
  );
  return response.data;
};

const activateDeviceApp = async (udid, adamId) => {
  const response = await axios.post(
    `${API_URL}/devices/${encodeURIComponent(udid)}/apps/${encodeURIComponent(adamId)}/activate`,
    {},
    { headers: jsonHeaders() }
  );
  return response.data;
};

const setDeviceAppConfig = async (udid, adamId, payload) => {
  const response = await axios.put(
    `${API_URL}/devices/${encodeURIComponent(udid)}/apps/${encodeURIComponent(adamId)}/config`,
    payload,
    { headers: jsonHeaders() }
  );
  return response.data;
};

const vppCatalogService = {
  getAppIcons,
  getAssets,
  getAsset,
  getAppLicenses,
  disassociateLicenses,
  getAppConfigs,
  createAppConfig,
  updateAppConfig,
  deleteAppConfig,
  putAppAssignments,
  getDeviceApps,
  reinstallDeviceApp,
  removeDeviceApp,
  activateDeviceApp,
  setDeviceAppConfig,
};
export default vppCatalogService;
